import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select
} from "@material-ui/core";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { Button } from "components";
import { useState } from "react";
import { MenuPopover } from "shared";

import { useStyles } from "./styles";

// Gera horários de 00:00 até 23:30 em intervalos de 30 minutos
const generateTimeOptions = () => {
  const times = [];
  for (let hour = 0; hour < 24; hour++) {
    for (const minute of [0, 30]) {
      const h = hour.toString().padStart(2, "0");
      const m = minute.toString().padStart(2, "0");
      times.push(`${h}:${m}`);
    }
  }
  return times;
};

export const Filter = ({ isOpen, setFilter, handleFilter, ...rest }) => {
  const classes = useStyles();
  const [filterData, setFilterData] = useState(() => {
    const date = new Date();
    date.setDate(date.getDate() - 1);

    return {
      hours: "00:00",
      date: date,
      stock: "physical_stock"
    };
  });

  const handleClose = () => {
    setFilter(state => ({
      ...state,
      isOpen: false
    }));
  };

  const handleFilterData = newFilter => {
    setFilterData(state => ({ ...state, ...newFilter }));
  };

  const handleFilterDate = async () => {
    const params = {};

    if (filterData.date !== null) {
      params.year = filterData.date.getFullYear();
      params.month = filterData.date.getMonth() + 1;
      params.day = filterData.date.getDate();
    }

    if (filterData.hours !== null && filterData.hours !== "") {
      const [hour, minute] = filterData.hours.split(":").map(Number);
      params.hour = hour;
      params.minute = minute;
    }

    setFilter(state => ({
      ...state,
      isOpen: false,
      params: {
        ...state.params,
        stock: filterData.stock,
        ...params
      }
    }));
  };

  return (
    <MenuPopover open={isOpen} onClose={handleClose} {...rest}>
      <Box className={classes.root}>
        <FormControl style={{ width: "100%" }}>
          <InputLabel>Estoque</InputLabel>
          <Select
            label="Estoque"
            value={filterData.stock}
            onChange={e => handleFilterData({ stock: e.target.value })}
          >
            <MenuItem value="physical_stock">Físico</MenuItem>
            <MenuItem value="storage_summary">Resumo</MenuItem>
          </Select>
        </FormControl>

        <KeyboardDatePicker
          label="Data"
          value={filterData.date}
          onChange={date => handleFilterData({ date })}
          format="MM/dd/yyyy"
        />

        <FormControl style={{ width: "100%" }}>
          <InputLabel>Horário</InputLabel>
          <Select
            label="Horário"
            value={filterData.hours}
            onChange={e => handleFilterData({ hours: e.target.value })}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 300
                }
              }
            }}
          >
            {generateTimeOptions().map(time => (
              <MenuItem key={time} value={time}>
                {time}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Button onClick={handleFilterDate}>Filtrar</Button>
      </Box>
    </MenuPopover>
  );
};
